import { COLOR } from '../types/theme';

const COLOR_MAP: Record<COLOR, string> = {
  [COLOR.Black]: 'var(--black)',
  [COLOR.Dark1]: 'var(--dark1)',
  [COLOR.Dark2]: 'var(--dark2)',
  [COLOR.Dark3]: 'var(--dark3)',
  [COLOR.Gold1]: 'var(--gold1)',
  [COLOR.Gold2]: 'var(--gold2)',
  [COLOR.Gray1]: 'var(--gray1)',
  [COLOR.Gray2]: 'var(--gray2)',
  [COLOR.Gray3]: 'var(--gray3)',
  [COLOR.Highlight]: 'var(--highlight)',
  [COLOR.White]: 'var(--white)',
};

export function colorToCss(color?: COLOR): string | undefined {
  return color ? COLOR_MAP[color] : undefined;
}
